import React from 'react';
import { Button } from 'virtues-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';

import { ReactComponent as IconFileDelete } from 'svg/trash.svg';
import { ReactComponent as IconFileDownload } from 'svg/file-download-solid.svg';
import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';
import { RESEARCHER } from 'constants/userRoles';
import s from './styles.module.scss';

const Summary = ({ t, lastUpdated, role, onRemoveFile, onDownloadFile }) => (
  <>
    <AdaptiveDataRow withLabelMargin title={t('reports.tachyReport.dateOfInclinicVisit')}>
      {moment(lastUpdated).format('MM/DD/YYYY')}
    </AdaptiveDataRow>
    <AdaptiveDataRow withLabelMargin title={t('reports.tachyReport.blockTitle')}>
      {t('reports.tachyReport.downloadText')}
      <div className={s.buttonGroup}>
        <Button icon={<IconFileDownload />} variant="secondary" onClick={onDownloadFile}>
          {t('download')}
        </Button>
        {role === RESEARCHER && (
          <Button icon={<IconFileDelete />} onClick={onRemoveFile} variant="primary">
            {t('reports.deleteReport')}
          </Button>
        )}
      </div>
    </AdaptiveDataRow>
  </>
);

Summary.propTypes = {
  lastUpdated: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
};

export default Summary;
